import { useFieldArray, useFormContext } from 'react-hook-form';

import { FileUploadInput } from '@ui/components/FileUploadInput';
import { FormInput, FormLabel, FormRow } from '@ui/components/Form/Form';
import { ThemeButton } from '@ui/components/ThemeButton';

import { UpdateClubFormValues } from '@features/club/ui/ClubInfoForm/ClubInfoForm';

import styles from '../ClubInfoForm/ClubInfoForm.module.css';

type Props = {
  onUploadSponsorLogo: (sponsorNumber: number, file: FormData) => Promise<unknown>;
};
export function ClubSponsorsInput({ onUploadSponsorLogo }: Props) {
  const {
    control,
    formState: { disabled },
  } = useFormContext<UpdateClubFormValues>();
  const { fields, append, remove } = useFieldArray<UpdateClubFormValues>({
    control,
    name: 'sponsors',
  });

  const sponsor = fields[0];
  const onUploadLogo = async (formData: FormData) => {
    if (sponsor) return;
    await onUploadSponsorLogo(1, formData);

    append({
      number: 1,
      caption: '',
      linkUri: '',
      text: '',
    });
  };

  return (
    <FormRow>
      <FormLabel>Логотип клуба со спонсорами</FormLabel>
      <FormInput className={styles.sponsorsValues}>
        <FileUploadInput
          className={styles.sponsorUploadInput}
          description="2 MB"
          value={sponsor?.logoUri}
          onChange={onUploadLogo}
          showPreview
          disabled={disabled}
        />

        <ThemeButton
          className={styles.deleteSponsorButton}
          onClick={() => remove(0)}
          disabled={disabled || !sponsor}
        >
          Удалить
        </ThemeButton>
      </FormInput>
    </FormRow>
  );
}
